import { createApp } from 'vue'
import NewMessage from './popPrompt.vue'

// 默认数据
const defaults = {
  message: {
    iconType: 'iconfont icon-piliangxuanze',
    title: ''
  },
  statusMsg: {
    status: 'warning'
  },
  loadingMsg: {
    additionalTips: '数据处理中...'
  }
}

// 存储所有活动实例的容器
const instances = new Set()

const msgMessage = (options = {}) => {
  // 创建应用实例
  const app = createApp(NewMessage, {
    type: options.type,
    options: options.options
  })
  
  // 创建容器并挂载
  const container = document.createElement('div')
  document.body.appendChild(container)
  
  const vm = app.mount(container)
  
  // 存储实例信息
  const instanceInfo = {
    vm,
    app,
    container,
    id: Date.now() + Math.random()
  }
  instances.add(instanceInfo)
  
  // 返回实例，方便后续操作
  return instanceInfo
}

// 挂载不同类型的方法
;['message', 'statusMsg', 'loadingMsg'].forEach(item => {
  msgMessage[item] = (options = {}) => {
    const defaultObj = defaults[item]
    const obj = {
      options: { ...defaultObj, ...options },
      type: item
    }
    return msgMessage(obj)
  }
})

// 关闭所有弹窗的方法
msgMessage.closeAll = () => {
  instances.forEach(instance => {
    if (instance.container && instance.container.parentNode) {
      instance.app.unmount()
      instance.container.parentNode.removeChild(instance.container)
    }
  })
  instances.clear()
}

// 插件安装方法
msgMessage.install = (app) => {
  // 在全局属性上挂载
  app.config.globalProperties.$msgMessage = msgMessage
  
  // 同时挂载各个快捷方法
  app.config.globalProperties.$message = msgMessage.message
  app.config.globalProperties.$statusMsg = msgMessage.statusMsg
  app.config.globalProperties.$loadingMsg = msgMessage.loadingMsg
}

export default msgMessage